import { render, staticRenderFns } from "./LoginFirebase.vue?vue&type=template&id=6c528ab0"
import script from "./LoginFirebase.vue?vue&type=script&lang=js"
export * from "./LoginFirebase.vue?vue&type=script&lang=js"
import style0 from "./LoginFirebase.vue?vue&type=style&index=0&id=6c528ab0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports